import classNames from 'classnames';
import React, { useRef, useState, useEffect } from 'react';
import css from './InCallControl.module.scss';
import { useDispatch } from 'react-redux';
import { actions, useSelector } from '../store';
import { selectCall } from '../store/reducers/janus';
import { BackIcon, PhoneDialIcon, PhoneHangUpIcon, PhoneMicrophoneMutedIcon, PhoneHoldIcon, PhoneKeypadIcon, ConnectionStatusIcon, PhoneVideoIcon, PhoneShareScreenIcon } from './icons';
import Keypad from './Keypad';
import { isCallConnected } from '../model';

export default function InCallControl() {
    const dispatch = useDispatch()
    const call = useSelector(selectCall)
    const prevCanDial = useRef(false)
    const [showDialpad, setShowDialpad] = useState(true)

    useEffect(() => {
        if (call.canHangUp) {
            setShowDialpad(false)
        } else if (!call.canDial && prevCanDial.current) {
            setShowDialpad(false)
        } else if (call.canDial && !prevCanDial.current) {
            setShowDialpad(true)
        }
        prevCanDial.current = call.canDial
    }, [call.canDial, call.canHangUp])

    function onDigit(digit: string) {
        if (call.canSendDtmf) {
            dispatch(actions.dtmf(digit))
        }
    }

    function toggleVideo(isScreenSharing: boolean) {
        dispatch(actions.toggleVideo(!call.hasLocalVideo, isScreenSharing ? 'window' : 'fhdres'))
    }

    return (
        <div>
            {showDialpad ?
                <div>
                    <Keypad onKeyPressed={onDigit} />
                    <button className={css.keypadDismiss} onClick={() => setShowDialpad(false)}><BackIcon /></button>
                </div>
                :
                <div className={css.buttons}>
                    <button onClick={() => setShowDialpad(true)}><PhoneKeypadIcon /></button>
                    <button onClick={() => { dispatch(actions.muteMicrophone(!call.isMuted)) }} className={classNames(call.isMuted && css.active)}><PhoneMicrophoneMutedIcon /></button>
                    <button onClick={() => {
                        if (call.canHold) {
                            dispatch(actions.hold())
                        } else if (call.canResume) {
                            dispatch(actions.resume())
                        }
                    }} disabled={!call.featureHoldResume || (!call.canHold && !call.canResume)} className={classNames(call.canResume && css.active)}><PhoneHoldIcon /></button>
                    <button onClick={() => toggleVideo(false)} className={classNames(call.hasLocalVideo && !call.isScreenSharing() && css.active)} disabled={!isCallConnected(call) || (call.hasLocalVideo && call.isScreenSharing())}><PhoneVideoIcon /></button>
                    <button onClick={() => toggleVideo(true)} className={classNames(call.hasLocalVideo && call.isScreenSharing() && css.active)} disabled={!isCallConnected(call) || (call.hasLocalVideo && !call.isScreenSharing())}><PhoneShareScreenIcon /></button>
                </div>
            }

            <div className={css.callButtons}>
                {call.canAnswer && <button onClick={() => dispatch(actions.answer())}><PhoneDialIcon /></button>}
                {call.canHangUp && <button className={css.hangUp} onClick={() => dispatch(actions.hangUp())}><PhoneHangUpIcon /></button>}
            </div>
        </div>
    )
}